import CmsImage from '@/cmsComponents/CmsImage';
import { LinkElement } from '@/cmsComponents/LinkElement';
import { Alignment } from '@/cmsComponents/constants';
import React from 'react';
import { IArticlePromotion } from 'types/cms';

import Grid from '@material-ui/core/Grid';

import { defaultAlt } from 'components/Image';

import styles from './style.module.scss';

interface IProps {
  promotion: IArticlePromotion;
}

export const ArticlePromotion: React.FC<IProps> = ({ promotion }) => {
  const { title, blurb, link, linkStyle, linkText } = promotion;
  return (
    <>
      <Grid container className={styles.container}>
        <Grid item xs={12} md>
          <div className={styles.contents}>
            <h2>{title}</h2>
            {blurb && <p>{blurb}</p>}
            {link && (
              <LinkElement
                linkText={linkText}
                link={link}
                linkStyle={linkStyle}
                align={Alignment.Left}
              />
            )}
          </div>
        </Grid>

        <Grid item xs={12} md>
          <div className={styles.img}>
            {promotion.image && (
              <CmsImage
                layout="fill"
                objectFit="cover"
                imageProps={promotion.image}
                altText={promotion.image.alternativeText || defaultAlt}
                format="large"
              />
            )}
          </div>
        </Grid>
      </Grid>
    </>
  );
};
